<template>
    <a-row class="order-not-ready">
        <a-col :span="24" class="message">
            <span>La orden no está lista, pedido retrasado en {{ elapsedTime }} minutos.</span>
        </a-col>
    </a-row>
</template>
<script>
export default {
    name: "OrderNotReady",
    props: {
        elapsedTime: {
            type: Number,
            required: true
        }
    }
};
</script>